export default __webpack_public_path__ + "static/media/trr-food-handheld-turkeyavocado.4b0af1e9.png";